@if (facilitiesLoaded) {
  <mat-form-field appearance="fill">
    @if (!isStoreUser) {
      <mat-label>Select an option</mat-label>
    }
    @if (isStoreUser) {
      <mat-label>Current Store</mat-label>
    }
    <mat-select [disabled]="isStoreUser" [(value)]="selectedFacility" (selectionChange)="updateFacilitySelected()">
      <mat-option [value]="0">None</mat-option>
      @for (facility of facilities; track facility) {
        <mat-option [value]="facility.facilityId.toString()">
          {{ facility.facilityId }} - {{ facility.facilityName }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}
@if (!facilitiesLoaded && isAuthed) {
  <div class="spinner-box">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
}
